/* eslint complexity: ["error", 40] */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Dialog from 'react-bootstrap-dialog';
import { Button, Modal, Form } from 'react-bootstrap';
import Iframe from 'react-iframe';
import { useTranslation } from 'react-i18next';
import { Formik, Field, FieldArray } from 'formik';
import { selectVideoForTagging, showUserVideoTagModal, newUserVideoTag, deleteUserVideoTags, userVideoTagSelected, exportHighlights, exportPlaylists, exportPlaylistsForSingleCamera, showUserTagModal, getTaggedUserVideos, showCameraModal, hideCameraModal, highlightOrPlaylistSelected, setSelectedUserVideoTags, clearSelectedUserVideoTags, setCameraSelection, exportHighlightsForSingleCamera } from '../actions/player';
import Configuration from '../config';
import PlayerVideoTag from './player-video-tag';
import { MultiSelect } from 'react-multi-select-component';
import {FaFilm, FaMagic, FaSave, FaTag, FaTrashAlt} from 'react-icons/fa';

const PlayerVideoTagging = ({
  gotoAllTaggetVideo,
  selectedVideoForTagging,
  userTags,
  showUserVideoTagModal,
  userVideoTags,
  deleteUserVideoTags,
  editUserVideoTagModal,
  exportHighlights,
  exportPlaylists,
  exportPlaylistForSingleCamera,
  exportHighlightsForSingleCamera,
  showPlayerTags,
  isCameraModalVisible,
  showCameraModal,
  hideCameraModal,
  exportHighlightOrPlaylist,
  selectedUserVideoTags,
  setValue,
  cameraSelections,
  setCameraSelection
}) => {
  const { t } = useTranslation();
  const [pendingStart, setPendingStart] = React.useState(null);
  
  if (selectedVideoForTagging === null) {
    return null;
  }

  const getStopTimeFromSeekTo = () => {
    const iframeRef = document.getElementById("videoTaggingIframe");
    if (!iframeRef) {
      return;
    }

    const stopTime = iframeRef.contentWindow.krpano.get("plugin[video].time");
    if (stopTime === null) {
      return 0;
    }

    return stopTime;
  };

  const onClickApplyTag = (videoId, userTag = null) => () => {
    let startTime = 0;
    let userTagId = null;
    const stopTime = Math.round(getStopTimeFromSeekTo());

    if (pendingStart !== null) {
      startTime = Math.round(pendingStart);
    } else if (userTag) {
      userTagId = userTag.id;
      if (stopTime > userTag.duration) {
        startTime = stopTime - userTag.duration;
      }
    }
  
    showUserVideoTagModal(videoId, stopTime, userTagId, startTime);
    setPendingStart(null);
  };

  const setMarker = (seconds, { asStart = false } = {}) => () => {
    const iframeRef = document.getElementById("videoTaggingIframe");
    if (!iframeRef) {
      return;
    }

    iframeRef.contentWindow.krpano.set("plugin[video].time", seconds);
    if (asStart) setPendingStart(seconds);
  };

  let dialog = null;
  const onRemove = (userVideoTags, videoId) => () => {
    dialog.show({
      title: t('CONFIRM'),
      body: t('CONFIRM_DELETE_TAG'),
      actions: [
        Dialog.Action(
          t('DELETE'),
          () => deleteUserVideoTags(userVideoTags, videoId),
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('CANCEL'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const exportSelected = cameras => {
    exportHighlights(selectedUserVideoTags, selectedVideoForTagging.videoId, cameras);
    hideCameraModal();
  };

  const exportPlaylist = cameras => {
    exportPlaylists(selectedUserVideoTags, selectedVideoForTagging.videoId, cameras);
    hideCameraModal();
  };

  const handleGotoAllTaggedVideo = () => {
    setValue([]);
    gotoAllTaggetVideo();
  };

  const handleExportPlaylistForSingleCamera = (values) => {
    const selectedTags = values.userVideoTags.filter(t => t.selected);
    const tagsMissingCamera = selectedTags.filter(t => !t.selectedSingleCameraId);

    if (tagsMissingCamera.length > 0) {
      dialog.show({
        title: t('ERROR'),
        body: t('PLEASE_SELECT_CAMERA_FOR_ALL_SELECTED_TAGS'),
        actions: [
          Dialog.Action(t('CLOSE_BUTTON'), null, 'btn btn_red_outline_rp')
        ],
        bsSize: 'small',
        onHide: dialog => dialog.hide()
      });
      return;
    }

    exportPlaylistForSingleCamera(selectedTags, selectedVideoForTagging.videoId);
  };

  const handleExportHighlightForSingleCamera = (values) => {
    const selectedTags = values.userVideoTags.filter(t => t.selected);
    const tagsMissingCamera = selectedTags.filter(t => !t.selectedSingleCameraId);
    
    if (tagsMissingCamera.length > 0) {
      dialog.show({
        title: t('ERROR'),
        body: t('PLEASE_SELECT_CAMERA_FOR_ALL_SELECTED_TAGS'),
        actions: [ Dialog.Action(t('CLOSE_BUTTON'), null, 'btn btn_red_outline_rp') ],
        bsSize: 'small',
        onHide: d => d.hide()
        });
          return;
    }
      exportHighlightsForSingleCamera(selectedTags, selectedVideoForTagging.videoId);
    };

  return (
    <div className="container pt-2">
      <div className="row mb-4">
        <div className="col-12">
          <div>
            <div className="d-flex" style={{ flexDirection: 'row', flexWrap: 'wrap' }}>

              <div className="mb-2 ml-auto d-xs-block"><Button className="myvideo-action myvideo-action--utility" onClick={handleGotoAllTaggedVideo}><FaFilm aria-hidden="true"/>{t('ALL_TAGGED_VIDEO')}</Button></div>
            </div>

            <div className="row justify-content-center">

              <div className="col-lg-10 mt-sm-2">
                <div><h6 className="mb-1 section_title_neg_rp">{t('VIDEO_TAGGING', { videoName: selectedVideoForTagging.name })}</h6></div>
                <div className="videoWrapper">
                  <Iframe allowFullScreen id="videoTaggingIframe" url={`${Configuration.krpanoPlayerUrl}?slotId=${selectedVideoForTagging.slotId}&token=${selectedVideoForTagging.token}`} />
                </div>
                <div className="d-flex">
                  <div className="ml-auto d-xs-block">
                    <Button className="myvideo-action myvideo-action--tag" onClick={onClickApplyTag(selectedVideoForTagging.videoId)} style={{ marginTop: 20, marginBottom: 20, marginLeft: 10, marginRight: 10 }}><FaTag aria-hidden="true"/>{t('TAG_APPLY')}</Button>
                    <Button className="myvideo-action myvideo-action--tag" onClick={showPlayerTags} style={{ marginTop: 20, marginBottom: 20, marginLeft: 10, marginRight: 10 }}><FaTag aria-hidden="true"/>{t('TAG_CREATE_OR_UPDATE')}</Button>
                  </div>

                </div>
              </div>


            </div>
            <hr className="hr_blue" />

            <div className="row">

              <div className="col-lg-12 mt-sm-2">
                {userTags.length <= 0 ? (<div style={{ color: "#00152F" }}>{t('NO_TAG_CREATED')}</div>) : <div><h5 style={{ color: "#00152F" }}>Tags</h5></div>}
                <h3 style={{ margin: 10 }}>
                  {userTags.map(t => <Button key={t.id} className="myvideo-tag-chip" style={{backgroundColor: t.color, borderColor: t.color}} onClick={onClickApplyTag(selectedVideoForTagging.videoId, t)}><FaTag aria-hidden="true"/>{t.label}</Button>)}
                </h3>
              </div>
              <div className="col-lg-12 mt-sm-2">
                <div>
                  <Formik
                    enableReinitialize
                    initialValues={{ userVideoTags, selectAll: false }}
                    onSubmit={values => console.log(values)}
                  >
                    {({ values, setFieldValue }) => {
                      const currentVideoId = selectedVideoForTagging?.videoId;
                      const handleSelectAll = () => {
                        const target = !values.selectAll;
                        setFieldValue('selectAll', target);
                        values.userVideoTags.forEach((t, index) =>
                          setFieldValue(`userVideoTags.${index}.selected`, target)
                        );
                      };

                      // userVideoTags.length <= 0 ? <div></div> :
                      return (
                        <>
                          <SyncSingleCameraSelection
                            selectedVideoForTagging={selectedVideoForTagging}
                            cameraSelections={cameraSelections}
                            values={values}
                            setFieldValue={setFieldValue}
                          />
                          {userVideoTags.length <= 0 ? <div></div> : (<Form>
                            <div className="row" style={{ color: '#000' }}>
                              <div className="col-12">
                                <Field
                                  name="selectAll"
                                  type="checkbox"
                                  style={{ marginRight: 10 }}
                                  onChange={handleSelectAll}
                                />
                                {t('SELECT_ALL')}
                              </div>
                            </div>
                            <hr className="hr_blue" />
                            <FieldArray name="userVideoTags">
                              {() => (
                                <div>
                                  {values.userVideoTags.length > 0 &&
                                    values.userVideoTags.map((userVideoTag, index) => (
                                      <Fragment key={index}>
                                        <div className="row align-items-center" style={{ color: '#000', }}>
                                          <div className="col d-flex align-items-center gap-2">
                                            <Field
                                              name={`userVideoTags.${index}.selected`}
                                              type="checkbox"
                                            />
                                            {/* <div className="col-auto">
                                      <Button onClick={setMarker(userVideoTag.startTime)}>{new Date(userVideoTag.startTime * 1000).toISOString().slice(11, 19)}</Button>
                                    </div> */}
                                            <div className="col-auto">
                                              <Form.Group>
                                                <Form.Control
                                                  required
                                                  as="select"
                                                  style={{ fontSize: '1em' }}
                                                  name={`userVideoTags.${index}.selectedSingleCameraId`}
                                                  value={userVideoTag.selectedSingleCameraId || ''}
                                                  onChange={e => {
                                                    const selectedId = Number(e.target.value);
                                                    if (userVideoTag.selectedSingleCameraId === selectedId) return;
                                                    const selectedCamera = selectedVideoForTagging.cameras.find(
                                                      cam => Number(cam.value) === selectedId
                                                    );
                                                    setFieldValue(`userVideoTags.${index}.selectedSingleCameraId`, selectedId);
                                                    if (selectedCamera) {
                                                      setFieldValue(`userVideoTags.${index}.isSingleCamera`, true);
                                                      setFieldValue(`userVideoTags.${index}.selectedSingleCameraName`, selectedCamera.label);
                                                    }

                                                    setCameraSelection(currentVideoId, index, {
                                                      id: selectedId,
                                                      name: selectedCamera?.label || ''
                                                    });
                                                  }}>
                                                  <option value="">{t('SELECT_CAMERA')}</option>
                                                  {selectedVideoForTagging.cameras.filter(camera => camera.camera_type === "flat" && camera.cameraExistInSlotCamera).map(camera => {
                                                    return (
                                                      <option key={camera.value} value={camera.value}>
                                                        {camera.label}
                                                      </option>
                                                    );
                                                  })}
                                                </Form.Control>
                                              </Form.Group>
                                            </div>

                                            <div className="col-auto">
                                              {t('FROM')}: <span
                                                              role="button"
                                                              tabIndex={0}
                                                              style={{ cursor: 'pointer' }}
                                                              onClick={setMarker(userVideoTag.startTime, { asStart: true })}
                                                              onKeyDown={(e) => {
                                                                if (e.key === 'Enter' || e.key === ' ')
                                                                  setMarker(userVideoTag.startTime, { asStart: true })();
                                                              }}
                                                            >
                                                              {new Date(userVideoTag.startTime * 1000).toISOString().slice(11, 19)}
                                                            </span> - {t('TO')}: {new Date(userVideoTag.stopTime * 1000).toISOString().slice(11, 19)}
                                            </div>

                                            <div className="col-auto">
                                              {userVideoTag.description}
                                            </div>
                                          </div>

                                          <div className="col-auto">
                                            <Button key={t.id} style={{ whiteSpace: 'nowrap', backgroundColor: userVideoTag.userTag.color, borderColor: userVideoTag.userTag.color, marginRight: 5 }} onClick={editUserVideoTagModal(userVideoTag)}>{userVideoTag.userTag.label}</Button>
                                          </div>
                                        </div>
                                        <hr className="hr_blue" />
                                      </Fragment>
                                    ))}
                                </div>
                              )}
                            </FieldArray>
                            <Button disabled={!values.userVideoTags.some(t => t.selected)} className="myvideo-action myvideo-action--danger" style={{ marginRight: 10, marginTop: 10 }} type="button" onClick={onRemove(values.userVideoTags, selectedVideoForTagging.videoId)}><FaTrashAlt aria-hidden="true"/>{t('REMOVE_TAG')}</Button>
                            <Button disabled={!values.userVideoTags.some(t => t.selected)} className="myvideo-action myvideo-action--highlight" style={{ marginRight: 10, marginTop: 10 }}type="button" onClick={() => handleExportHighlightForSingleCamera(values)}><FaMagic aria-hidden="true"/>{t('EXPORT_HIGHLIGHT')}</Button>
                            <Button
                              disabled={!values.userVideoTags.some(t => t.selected)}
                              type="button"
                              className="myvideo-action myvideo-action--playlist"
                              style={{marginTop: 10}} onClick={() => {handleExportPlaylistForSingleCamera(values);}}><FaFilm aria-hidden="true"/>{t('EXPORT_PLAYLIST')}</Button>
                            <Dialog
                              ref={el => {
                                dialog = el;
                              }} />
                          </Form>)}
                        </>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PlayerVideoTag />
      <Modal show={isCameraModalVisible} onHide={hideCameraModal}>
        <Modal.Header closeButton>
          <Modal.Title>{t('CAMERAS')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t('TAG_CHOOSE_CAMERAS')}</p>
          {
            <Formik
              initialValues={{ selectedUserVideoTags, cameras: selectedVideoForTagging.cameras, selectedCameras: selectedVideoForTagging.cameras.length === 1 ? selectedVideoForTagging.cameras : [] }}
              onSubmit={values => exportHighlightOrPlaylist === "highlight" ? exportSelected(values.selectedCameras) : exportPlaylist(values.selectedCameras)}
            >
              {({
                handleSubmit,
                handleChange,
                setFieldValue,
                values
              }) => {

                return (
                  <Form onSubmit={handleSubmit}>
                    <Form.Group>
                      <Form.Label>{t('CAMERAS')}</Form.Label>
                      <div style={{ color: 'black' }}>
                        <MultiSelect
                          options={values.cameras}
                          value={values.selectedCameras}
                          onChange={value => setFieldValue('selectedCameras', value)}
                          labelledBy="SelectCamera"
                          overrideStrings={{
                            "allItemsAreSelected": t('ALL_CAMERAS'),
                            "search": t('SEARCH'),
                            "selectAll": t('SELECT_ALL'),
                            "selectSomeItems": t('CAMERA_SELECT'),
                            "selectAllFiltered": t('SELECT_ALL'),
                          }}
                          ClearSelectedIcon={null}
                        />
                        <input
                          name="hiddenRequired"
                          style={{ height: 0, width: 0, opacity: 0 }}
                          value={values.selectedCameras.length ? "1" : ""}
                          required
                        />
                      </div>
                    </Form.Group>
                    <Button className="myvideo-action myvideo-action--primary" type="submit"><FaSave aria-hidden="true"/>{t('SAVE')}</Button>
                  </Form>
                );
              }}
            </Formik>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={hideCameraModal}>
            {t('CLOSE_BUTTON')}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

function SyncSingleCameraSelection({ selectedVideoForTagging, cameraSelections, values, setFieldValue }) {
  const selectedVideoId = selectedVideoForTagging?.videoId;

  React.useEffect(() => {
    if (!selectedVideoId) return;
    const selections = cameraSelections?.[selectedVideoId] || {};

    values.userVideoTags.forEach((tag, index) => {
      const camera = selections[index];
      if (
        camera &&
        camera.id &&
        (!tag.selectedSingleCameraId || tag.selectedSingleCameraId !== camera.id)
      ) {
        setFieldValue(`userVideoTags.${index}.selectedSingleCameraId`, camera.id);
        setFieldValue(`userVideoTags.${index}.isSingleCamera`, true);
        setFieldValue(`userVideoTags.${index}.selectedSingleCameraName`, camera.name);
      }
    });
  }, [selectedVideoId, values.userVideoTags, cameraSelections, setFieldValue]);

  return null;
}

PlayerVideoTagging.propTypes = {
  gotoAllTaggetVideo: PropTypes.func.isRequired,
  selectedVideoForTagging: PropTypes.object,
  userTags: PropTypes.array,
  showUserVideoTagModal: PropTypes.func.isRequired,
  userVideoTags: PropTypes.array,
  deleteUserVideoTags: PropTypes.func.isRequired,
  editUserVideoTagModal: PropTypes.func.isRequired,
  showPlayerTags: PropTypes.array.isRequired
};

PlayerVideoTagging.defaultProps = {
  selectedVideoForTagging: null,
  userTags: [],
  userVideoTags: []
};

const mapStateToProps = ({ player: { selectedVideoForTagging, userTags, userVideoTags, isCameraModalVisible, exportHighlightOrPlaylist, selectedUserVideoTags, cameraSelections } }) => ({
  selectedVideoForTagging,
  userTags,
  userVideoTags,
  isCameraModalVisible,
  exportHighlightOrPlaylist,
  selectedUserVideoTags,
  cameraSelections
});

const mapDispatchToProps = dispatch => ({
  gotoAllTaggetVideo: () => {
    dispatch(selectVideoForTagging(null));
    dispatch(getTaggedUserVideos());
  },
  showUserVideoTagModal: (videoId, stopTime, userTagId = null, startTime = 0) => {
    dispatch(newUserVideoTag(videoId, stopTime, userTagId, startTime));
    dispatch(showUserVideoTagModal());
  },
  deleteUserVideoTags: (uservideoTags, videoId) => {
    dispatch(deleteUserVideoTags(uservideoTags.filter(t => t.selected), videoId));
  },
  editUserVideoTagModal: userVideoTag => () => {
    dispatch(userVideoTagSelected(userVideoTag));
    dispatch(showUserVideoTagModal());
  },
  exportHighlights: (uservideoTags, videoId, selectedCameras) => {
    for (const tag of uservideoTags) {
      if (tag.description === null)
        tag.description = "---";
    }

    dispatch(exportHighlights(uservideoTags, videoId, selectedCameras));
  },
  exportPlaylists: (uservideoTags, videoId, selectedCameras) => {
    dispatch(exportPlaylists(uservideoTags, videoId, selectedCameras));
  },
  exportPlaylistForSingleCamera: (userVideoTags, videoId) => {
    dispatch(exportPlaylistsForSingleCamera(userVideoTags, videoId));
  },
  setCameraSelection: (videoId, index, camera) => dispatch(setCameraSelection(videoId, index, camera)),
  showPlayerTags: () => {
    dispatch(showUserTagModal());
  },
  showCameraModal: (highlightOrPlaylist, selectedUserVideoTags) => {
    dispatch(highlightOrPlaylistSelected(highlightOrPlaylist));
    dispatch(setSelectedUserVideoTags(selectedUserVideoTags));
    dispatch(showCameraModal());
  },
  hideCameraModal: () => {
    dispatch(highlightOrPlaylistSelected(null));
    dispatch(clearSelectedUserVideoTags());
    dispatch(hideCameraModal());
  },
  exportHighlightsForSingleCamera: (userVideoTags, videoId) => {
    dispatch(exportHighlightsForSingleCamera(userVideoTags, videoId));
  },
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerVideoTagging));
